import React, { useEffect, useState } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { GIFTCARD_CONSTANTS } from '../Constants/giftcardConstants';
import CheckbalancdeModal from './checkGiftcard.js';
import { MaterialTextInput } from 'atoms/MaterialInput';
import { useSelector, useDispatch } from 'react-redux';
import { resetGiftcardCheckBal } from '@kfc-global/react-shared/redux/Actions/GiftCheckBalanceAction';
import {
  giftCardPurchaseService,
  resetPurchaseAction,
} from '@kfc-global/react-shared/redux/Actions/GiftCardPurchaseAction';
import {
  resetGiftCardPurchaseStatusAction,
  giftCardPurchaseStatusAction,
} from '@kfc-global/react-shared/redux/Actions/PaymentGiftCardAction';
import GiftCardPurchaseForm from './GiftCardPurchaseForm';
import SuccessfulPurchase from './SuccessfulPurchase';
import { useLocation } from 'react-router-dom';
import { ButtonComp } from 'atoms/Buttons';
import { getEmbeddedErrorMessageAnalytic } from '../../../common/utilities/utils';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/homePageContainerConstants';
import { embeddedErrorMessageAnalyticFn } from 'components/checkout/CheckoutFn';

const { PAYMENT_FAILED_MESSAGE, KFC_Gift_Card } = HOME_PAGE_CONTAINER_CONSTANTS;

export const isValidEmail = email => {
  let pattern = GIFTCARD_CONSTANTS.EMAIL_REGEX;
  return pattern.test(email);
};

export const updateUserName = (userFullName, inputValue) => {
  let pattern = GIFTCARD_CONSTANTS.NAME_REGX;
  let fullNameObj = { ...userFullName };
  fullNameObj.value = inputValue;
  if (pattern.test(inputValue)) {
    fullNameObj.error = true;
    fullNameObj.errorMessage = translateWithI18Next('namevalidationmsg');
  } else if (!inputValue || inputValue.length < 2 || inputValue.length > 26) {
    fullNameObj.error = true;
    fullNameObj.errorMessage = translateWithI18Next('emptyYourNameErrMsg');
  } else {
    fullNameObj.error = false;
    fullNameObj.errorMessage = '';
  }
  return fullNameObj;
};

export const updateUserPhone = (userPhone, inputValue) => {
  let phoneObj = { ...userPhone };
  phoneObj.value = inputValue;
  if (!inputValue) {
    phoneObj.error = true;
    phoneObj.errorMessage = translateWithI18Next('phonenumberEmptyHelpText');
  } else if (inputValue.length !== 10 || isNaN(inputValue)) {
    phoneObj.error = true;
    phoneObj.errorMessage = translateWithI18Next('invalidPhoneNumberErrText');
  } else {
    phoneObj.error = false;
    phoneObj.errorMessage = '';
  }
  return phoneObj;
};

export const updateUserEmail = (userEmail, inputValue) => {
  let emailObj = { ...userEmail };
  emailObj.value = inputValue;
  if (!inputValue) {
    emailObj.error = true;
    emailObj.errorMessage = translateWithI18Next('yourEmailHelpText');
  } else if (!isValidEmail(inputValue)) {
    emailObj.error = true;
    emailObj.errorMessage = translateWithI18Next('invalidYourEmailErrText');
  } else {
    emailObj.error = false;
    emailObj.errorMessage = '';
  }
  return emailObj;
};

export const updateReceptEmail = (recptEmail, inputValue) => {
  let emailObj = { ...recptEmail };
  emailObj.value = inputValue;
  if (!inputValue) {
    emailObj.error = true;
    emailObj.errorMessage = translateWithI18Next('recipientEmptyEmailHelpText');
  } else if (!isValidEmail(inputValue)) {
    emailObj.error = true;
    emailObj.errorMessage = translateWithI18Next('invalidRecipientEmailErrText');
  } else {
    emailObj.error = false;
    emailObj.errorMessage = '';
  }
  return emailObj;
};

const BuyGiftCard = props => {
  const [openModal, toggleModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(true);
  const { headerData = {}, desktopImage = {}, giftAmount = {}, termsncondition = {} } = props.contentData;
  const isMobile = props.isMobile;
  const {
    BALANCEBUTTON_TEXT,
    RECP_EMAIL_PLACEHOLDER,
    NAME_PLACEHOLDER,
    YOUR_EMAIL_PLACEHOLDER,
    PHONE_PLACEHOLDER,
    MESSAGE_PLACEHOLDER,
    CANCELBUTTON_TEXT,
    PAYMENTBUTTON_TEXT,
    FORM_VALUES,
    MESSAGE_HEADING,
    INFOMATION_HEADING,
    CUSTOM,
    MANDATORY_NOTE,
  } = GIFTCARD_CONSTANTS;

  const dispatch = useDispatch();
  const location = useLocation();
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { tenantId, currencySymbol } = tenantReducer || {};
  const customerId = useSelector(({ profileReducer: { customerId } }) => customerId);
  const giftCardPurchaseReducer = useSelector(data => data.giftCardPurchaseReducer);
  const { giftCardPurchaseData = {}, isPurchaseSuccess = false, isPurchaseLoading } = giftCardPurchaseReducer || {};
  const paymentsGiftCardReducer = useSelector(data => data.paymentsGiftCardReducer);
  const { giftCardPurchaseStatResp = {} } = paymentsGiftCardReducer || {};

  const successPurchasehandler = () => {
    localStorage.setItem('paymentStatus', '');
    localStorage.setItem('postPaymentType', '');
    dispatch(resetGiftCardPurchaseStatusAction());
    dispatch(resetPurchaseAction());
    setOpenSuccessModal(false);
    window.location.reload();
  };

  const handleCloseModal = event => {
    event.preventDefault();
    toggleModal(false);
  };

  useEffect(() => {
    const closeCheckBalanceModal = eventofCheckBalanceModal => {
      if (eventofCheckBalanceModal.keyCode === 27) {
        handleCloseModal(eventofCheckBalanceModal);
      }
    };
    window.addEventListener('keydown', closeCheckBalanceModal);
    return () => window.removeEventListener('keydown', closeCheckBalanceModal);
  }, []);

  const openbalanceModal = () => {
    toggleModal(true);
    dispatch(resetGiftcardCheckBal());
  };

  const [recptEmail, setRecptEmail] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const [userFullName, setUserFullName] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const [userEmail, setUserEmail] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const [userPhone, setUserPhone] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const [userMsg, setUserMsg] = useState('');
  const [userAmt, setUserAmt] = useState('');
  const [displayForm, setDisplayForm] = useState(false);
  const [disablebutton, setDisabled] = useState(true);
  const [ShowFailureError, setShowFailureError] = useState(false);

  const clearInputFields = () => {
    setRecptEmail({ value: '' });
    setUserFullName({ value: '' });
    setUserEmail({ value: '' });
    setUserPhone({ value: '' });
    setUserMsg('');
    setUserAmt('');
  };

  const submitForm = () => {
    if (userAmt > 0 && (userEmail.value && userPhone.value && userFullName.value && recptEmail.value) !== '') {
      dispatch(
        giftCardPurchaseService({
          body: {
            RecipientEmail: recptEmail.value,
            BuyerName: userFullName.value,
            BuyerEmail: userEmail.value,
            BuyerMobileNumber: userPhone.value,
            Message: userMsg,
            GiftCardAmount: userAmt,
          },
          tenantId: tenantId,
          customerId: customerId,
        }),
      );
    }
  };

  useEffect(() => {
    if (userAmt > 0 && (userEmail.value && userPhone.value && userFullName.value && recptEmail.value) !== '') {
      if ((userEmail.error || userPhone.error || userFullName.error || recptEmail.error) === false) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    } else {
      setDisabled(true);
    }
  }, [recptEmail, userFullName, userEmail, userPhone, userAmt]);

  useEffect(() => {
    embeddedErrorMessageAnalyticFn(KFC_Gift_Card, userFullName.error, userFullName.errorMessage);
  }, [userFullName.errorMessage, userFullName.error]);

  useEffect(() => {
    embeddedErrorMessageAnalyticFn(KFC_Gift_Card, userPhone.error, userPhone.errorMessage);
  }, [userPhone.errorMessage, userPhone.error]);

  useEffect(() => {
    embeddedErrorMessageAnalyticFn(KFC_Gift_Card, userEmail.error, userEmail.errorMessage);
  }, [userEmail.errorMessage, userEmail.error]);

  useEffect(() => {
    embeddedErrorMessageAnalyticFn(KFC_Gift_Card, recptEmail.error, recptEmail.errorMessage);
  }, [recptEmail.errorMessage, recptEmail.error]);

  useEffect(() => {
    if (isPurchaseSuccess) {
      setDisplayForm(true);
    }
  }, [isPurchaseSuccess]);

  useEffect(() => {
    if (location?.ShowFailureError) {
      setShowFailureError(true);
      getEmbeddedErrorMessageAnalytic('KFC Gift Card', PAYMENT_FAILED_MESSAGE);
    }
  }, [location?.ShowFailureError]);

  useEffect(() => {
    if (
      localStorage.getItem('postPaymentType') === 'giftCardPurchase' &&
      localStorage.getItem('paymentStatus') === 'Success'
    ) {
      tenantId &&
        dispatch(
          giftCardPurchaseStatusAction({
            tenantId: tenantId,
            orderId: giftCardPurchaseData?.orderId,
          }),
        );
      //adding analytic method for buying a giftcard KRM-10620
      //   GiftCardSuccess({
      //     item_name: 'KFC e-Gift Card',
      //     item_id: giftCardPurchaseData.orderId || 'NA',
      //     price: giftCardPurchaseData.transactionAmount || 'NA',
      //     item_list_name: 'Gift Cards',
      //     index: 1 ,
      //     quantity: 1 ,
      //  });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem('paymentStatus')]);
  const OnclickSetAmount = (evt, amount, currency) => {
    let giftAmountElement = document.getElementById('gift-amount');
    giftAmountElement.setAttribute('aria-label', amount + currency + 'selected');
  };
  const updateFormDetails = (e, select) => {
    let inputValue = e.target.value;

    if (select === FORM_VALUES.USER_FULL_NAME) {
      setUserFullName({
        ...updateUserName(userFullName, inputValue),
      });
    }
    if (select === FORM_VALUES.USER_PHONE) {
      setUserPhone({
        ...updateUserPhone(userPhone, inputValue),
      });
    }
    if (select === FORM_VALUES.USER_EMAIL) {
      setUserEmail({
        ...updateUserEmail(userEmail, inputValue),
      });
    }
    if (select === FORM_VALUES.RECP_EMAIL) {
      setRecptEmail({
        ...updateReceptEmail(recptEmail, inputValue),
      });
    }
    if (select === FORM_VALUES.MESSAGE) {
      setUserMsg(inputValue);
    }
  };

  return (
    <div className='giftcard-container'>
      <div className='giftcard-headline-container'>
        <h1 className='giftcard-headline'>{headerData.headline}</h1>
        <button
          data-testid='toggle-modal'
          className='button whiteButton blackBorder check-balance'
          onClick={() => openbalanceModal()}
        >
          {translateWithI18Next(BALANCEBUTTON_TEXT)}
        </button>
        {openModal && (
          <CheckbalancdeModal tenantId={tenantReducer.tenantId} isOpen={openModal} handleClose={handleCloseModal} />
        )}
      </div>

      <div className='main-container'>
        <h2 className='buy-card-text'>{headerData.subHeadline}</h2>
        <img src={desktopImage.url} alt={'KFC Gift Card'} className='card-image' />
        <div className='card-amount-container'>
          <h3 className='card-amount-heading container-heading'>{giftAmount.title}</h3>
          <div className='amount-list'>
            {giftAmount &&
              giftAmount.list &&
              giftAmount.list.map((amount, index) => {
                return (
                  <React.Fragment>
                    <ButtonComp
                      data-testid='selected-amt'
                      id='gift-amount'
                      className={amount === userAmt ? 'amount-block amount-block-select' : 'amount-block'}
                      onClick={evt => {
                        setUserAmt(amount);
                        OnclickSetAmount(evt, amount, currencySymbol);
                      }}
                      ariaLable={amount + currencySymbol}
                    >
                      {currencySymbol}
                      {amount}
                    </ButtonComp>
                  </React.Fragment>
                );
              })}
            {tenantReducer?.country !== 'INDIA' && <div className='amount-block'>{CUSTOM}</div>}
          </div>
        </div>
        <div className='infomation-container'>
          <h3 className='information-heading container-heading'>{INFOMATION_HEADING}</h3>
          <div className='infomation-input-container'>
            {!isMobile && <p className='mandatory-note'>{translateWithI18Next(MANDATORY_NOTE)}</p>}
            <MaterialTextInput
              data-testid='recept-email'
              autoComplete='on'
              value={recptEmail.value}
              labelClassName='info-label'
              inputClassName='info-input'
              helperTextClassName='error-text'
              placeholder={translateWithI18Next(RECP_EMAIL_PLACEHOLDER)}
              aria-required='true'
              onChange={e => updateFormDetails(e, FORM_VALUES.RECP_EMAIL)}
              helperText={recptEmail.errorMessage}
              error={recptEmail.error}
            />
            <MaterialTextInput
              data-testid='user-name'
              autoComplete='on'
              value={userFullName.value}
              labelClassName='info-label'
              inputClassName='info-input'
              helperTextClassName='error-text'
              maxlength='26'
              aria-required='true'
              placeholder={translateWithI18Next(NAME_PLACEHOLDER)}
              onChange={e => updateFormDetails(e, FORM_VALUES.USER_FULL_NAME)}
              helperText={userFullName.errorMessage}
              error={userFullName.error}
            />
            <MaterialTextInput
              data-testid='user-email'
              autoComplete='on'
              value={userEmail.value}
              labelClassName='info-label'
              inputClassName='info-input'
              helperTextClassName='error-text'
              aria-required='true'
              placeholder={translateWithI18Next(YOUR_EMAIL_PLACEHOLDER)}
              onChange={e => updateFormDetails(e, FORM_VALUES.USER_EMAIL)}
              helperText={userEmail.errorMessage}
              error={userEmail.error}
            />
            <MaterialTextInput
              data-testid='user-phone'
              autoComplete='on'
              value={userPhone.value}
              labelClassName='info-label'
              inputClassName='info-input'
              helperTextClassName='error-text'
              maxlength='10'
              aria-required='true'
              placeholder={translateWithI18Next(PHONE_PLACEHOLDER)}
              onChange={e => updateFormDetails(e, FORM_VALUES.USER_PHONE)}
              helperText={userPhone.errorMessage}
              error={userPhone.error}
            />
          </div>
        </div>
        <div className='msg-container'>
          <h3 className='msg-heading container-heading'>{MESSAGE_HEADING}</h3>
          <textarea
            data-testid='msg-input'
            value={userMsg}
            className='msg-inputbox'
            placeholder={translateWithI18Next(MESSAGE_PLACEHOLDER)}
            aria-label={translateWithI18Next(MESSAGE_PLACEHOLDER)}
            onChange={e => updateFormDetails(e, FORM_VALUES.MESSAGE)}
          />
        </div>
      </div>
      <div id='terms-condition-button-container'>
        <div className='terms-condition-container'>
          <div className='terms-condition-title' aria-label={termsncondition.title}>
            {termsncondition.title}
          </div>
          <div className='terms-condition-data' aria-label={termsncondition.data}>
            {termsncondition.data}
          </div>
        </div>
        <div className='button-container'>
          <button
            data-testid='clear-input'
            className='button whiteButton blackBorder cancel-button'
            onClick={() => clearInputFields()}
          >
            {translateWithI18Next(CANCELBUTTON_TEXT)}
          </button>
          <button
            data-testid='payment-button'
            className='button redButton payment-button payment-button-in'
            disabled={disablebutton || isPurchaseLoading}
            onClick={() => submitForm()}
          >
            {translateWithI18Next(PAYMENTBUTTON_TEXT)}
          </button>
        </div>
      </div>
      {displayForm && <GiftCardPurchaseForm giftCardPurchaseData={giftCardPurchaseData} />}

      {openSuccessModal && (ShowFailureError || localStorage.getItem('paymentStatus') === 'Success') && (
        <SuccessfulPurchase
          isOpen={openSuccessModal}
          handleClose={() => successPurchasehandler()}
          purchaseStatus={giftCardPurchaseStatResp?.purchaseStatus}
          paymentStatus={localStorage.getItem('paymentStatus')}
        />
      )}
    </div>
  );
};
export default BuyGiftCard;
